<template>
    <div class="score-graph">
        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import Chart from 'chart.js/auto';
import { eventService } from '../services/api';

export default {
    name: 'CheckInScoreGraph',
    props: {
        userId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const chartCanvas = ref(null);
        let chart = null;
        const chartData = ref({
            dates: [],
            businessScores: [],
            healthScores: [],
            personalScores: []
        });

        const loadScores = async () => {
            try {
                const response = await eventService.getCheckInScores(props.userId);
                
                const dates = response.map(score => new Date(score.check_in_date).toLocaleDateString());
                const businessScores = response.map(score => score.business_score);
                const healthScores = response.map(score => score.health_score);
                const personalScores = response.map(score => score.personal_score);
                
                chartData.value = {
                    dates,
                    businessScores,
                    healthScores,
                    personalScores
                };

                if (chart) {
                    chart.destroy();
                }

                chart = new Chart(chartCanvas.value, {
                    type: 'line',
                    data: {
                        labels: dates,
                        datasets: [
                            {
                                label: 'Business',
                                data: businessScores,
                                borderColor: '#4285f4',
                                backgroundColor: 'rgba(66, 133, 244, 0.1)',
                                fill: true,
                                tension: 0.4
                            },
                            {
                                label: 'Health',
                                data: healthScores,
                                borderColor: '#34a853',
                                backgroundColor: 'rgba(52, 168, 83, 0.1)',
                                fill: true,
                                tension: 0.4
                            },
                            {
                                label: 'Personal',
                                data: personalScores,
                                borderColor: '#ea4335',
                                backgroundColor: 'rgba(234, 67, 53, 0.1)',
                                fill: true,
                                tension: 0.4
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                max: 10,
                                ticks: {
                                    stepSize: 1
                                }
                            },
                            x: {
                                ticks: {
                                    maxRotation: 45,
                                    minRotation: 45
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'top'
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false
                            }
                        }
                    }
                });
            } catch (error) {
                console.error('Error loading check-in scores:', error);
            }
        };

        onMounted(loadScores);
        watch(() => props.userId, loadScores);

        return {
            chartCanvas
        };
    }
};
</script>

<style scoped>
.score-graph {
    width: 100%;
    height: 400px;
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin: 20px 0;
}
</style> 